<template>
  <div class="scores-container">
    <div class="risk-score-card">
      <i class="fa fa-chart-pie risk-icon"> Goal Management       <!-- Add New Budget Button -->
      <button @click="showAddBudgetModal = !showAddBudgetModal">
        {{ showAddBudgetModal ? 'Cancel' : 'Add' }} <i class="fas fa-plus"></i>
      </button></i>  
    </div>

    <div class="budgets-container">
      <div v-if="showAddBudgetModal" class="budget-form">
        <select v-model="currentBudget.category">
          <option value="Travel">Travel</option>
          <option value="Taxes">Taxes</option>
          <option value="Family">Family, Pets & Relationships</option>
          <option value="Income">Income & Savings</option>
          <option value="Financial">Financial Expenses & Insurance</option>
          <option value="Shopping">Shopping & Apparel</option>
          <option value="Entertainment">Entertainment & Hobbies</option>
          <option value="Health">Health & Wellness</option>
          <option value="Food">Food & Dining</option>
          <option value="Auto">Auto & Transportation</option>
          <option value="Home">Home & Utilities</option>
        </select>
        <input type="text" v-model="currentBudget.budget_name" placeholder="Name">
        <input type="date" v-model="currentBudget.start_date" placeholder="Start Date">
        <input type="date" v-model="currentBudget.end_date" placeholder="End Date">
        <input type="number" v-model="currentBudget.goal_amount" placeholder="Goal Amount">
        <input type="number" v-model="currentBudget.saved_amount" placeholder="Saved Amount">
        <input type="checkbox" v-model="currentBudget.expected" placeholder="Expected Expense">

        <button @click="isEditing ? updateBudget() : addBudget()">
          {{ isEditing ? 'Update Budget' : 'Add Budget' }}
        </button>
      </div>

      <!-- List of Budgets -->
      <table>
        <thead>
          <tr>
            <th>Category</th>
            <th>Goal Name</th>
            <th>Start Date</th>
            <th>Goal End Date</th>
            <th>Amount Estimated</th>
            <th>Amount Saved</th>
            <th>Amount Remaining</th>
            <th>Expected</th>
            <th>Days Remaining</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(budget, index) in budgets" :key="index">
            <td>{{ budget.category }}</td>
            <td>{{ budget.budget_name }}</td>
            <td>{{ budget.start_date }}</td>
            <td>{{ budget.end_date }}</td>
            <td>${{ budget.goal_amount }}</td>
            <td>${{ budget.saved_amount }}</td>
            <td>${{ budget.goal_amount - budget.saved_amount }}</td>
            <td>{{ displayExpectedText(budget.expected) }}</td>
            <td>{{ calculateDaysRemaining(budget.end_date) }} days remaining</td>
            <td>
              <button @click="selectBudgetForUpdate(budget, index)">Edit</button>
            </td>
          </tr>
        </tbody>
      </table><br>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      budgets: [],
      currentBudget: {
        id: null,
        category: '',
        budget_name: '',
        goal_amount: 0,
        saved_amount: 0,
        start_date: '',
        end_date: '',
        expected: false,
      },
      selectedBudgetIndex: null,
      showAddBudgetModal: false,
      isEditing: false
    };
  },
  methods: {
    async fetchBudgets() {
      const user = await Auth.currentAuthenticatedUser();
      const response = await axios.get('https://api.riskypaws.com/frontoffice/api/budget/', {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.budgets = response.data;
    },
    displayExpectedText(expected) {
      return expected ? 'Yes' : 'No';
    },
    selectBudgetForUpdate(budget, index) {
      this.currentBudget = { ...budget };
      this.selectedBudgetIndex = index;
      this.showAddBudgetModal = true;
      this.isEditing = true;
    },
    async updateBudget() {
      const user = await Auth.currentAuthenticatedUser();
      await axios.put(`https://api.riskypaws.com/frontoffice/api/budget/${this.currentBudget.id}/`, this.currentBudget, {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.resetForm();
      await this.fetchBudgets();
    },
    resetForm() {
      this.currentBudget = { id: null, category: '', budget_name: '', goal_amount: 0, saved_amount: 0, start_date: '', end_date: '', expected: false };
      this.showAddBudgetModal = false;
      this.isEditing = false;
    },
    async addBudget() {
      const user = await Auth.currentAuthenticatedUser();
      await axios.post('https://api.riskypaws.com/frontoffice/api/budget/', this.currentBudget, {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.resetForm();
      await this.fetchBudgets();
    },
    calculateDaysRemaining(endDate) {
      const today = new Date();
      const end = new Date(endDate);
      const timeDiff = end - today;
      return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
    }
  },
  created() {
    this.fetchBudgets();
  }
};
</script>




<style scoped>

.scores-container {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: white;
  border: 2px solid #4A148C;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.risk-score-card {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  padding: 15px;
  border-radius: 10px;
}

.budget-form select,
.budget-form input[type="text"],
.budget-form input[type="date"],
.budget-form input[type="number"],
.budget-form input[type="checkbox"] {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-sizing: border-box;
}

button {
  background-color: #4A148C;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: black;
}

/* Table Styles */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  border: 1px solid #4A148C;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f4f4f4;
  color: #333;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .scores-container table,
  .scores-container thead,
  .scores-container tbody,
  .scores-container th,
  .scores-container td,
  .scores-container tr {
    display: block;
    width: 100%;
  }
 .button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}
.scores-container th {
    display: none;
  }

.scores-container td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:10px;
margin-bottom: 10px;
border-bottom: 1px solid #ddd;
text-align: right;
}

.scores-container td:before {
content: attr(data-label);
font-weight: bold;
flex-basis: 40%;
text-align: left;
}

.scores-container td[data-label="Actions"] button {
flex-grow: 1;
}
}

</style>